import { API } from '@/constant/constants'
import {
  DATA_PAGINATION,
  Location,
  SETUP_STATUS,
  SearchParams,
  Site,
  UPDATE_STATION_DATA,
} from '@/types'
import { Controller } from '@/types/controller'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export const setupApi = {
  getOverAllStatus(interfaceId: number) {
    const url = API.CONFIG_SETUP.DEFAULT.replace(
      ':interfaceId',
      `${interfaceId}`,
    )
    return axiosClient.get<SETUP_STATUS>(url)
  },
  getCommonData(interfaceId: number) {
    const url = API.CONFIG_SETUP.COMMON_DATA.DEFAULT.replace(
      ':interfaceId',
      `${interfaceId}`,
    )
    return axiosClient.get<SETUP_STATUS>(url)
  },
  getDiscoverData(interfaceId: number) {
    const url = API.CONFIG_SETUP.DISCOVER_DATA.DEFAULT.replace(
      ':interfaceId',
      `${interfaceId}`,
    )
    return axiosClient.post<DATA_PAGINATION<Controller>>(url)
  },
  getSites(interfaceId: number, searchParams: SearchParams = {}) {
    const url = `${
      API.CONFIG_SETUP.SITE.DEFAULT
    }/${interfaceId}${queryStringify(searchParams)}`
    return axiosClient.get<DATA_PAGINATION<Site>>(url)
  },
  getLocations(siteId: number, searchParams: SearchParams = {}) {
    const url = `${API.CONFIG_SETUP.LOCATION.DEFAULT}/${siteId}${queryStringify(
      searchParams,
    )}`
    return axiosClient.get<DATA_PAGINATION<Location>>(url)
  },
  getControllers(interfaceId: number) {
    const url = API.CONFIG_SETUP.CONTROLLER.DEFAULT
    return axiosClient.get<DATA_PAGINATION<Controller>>(url, {
      params: { interfaceId: interfaceId, PageSize: 9999 },
    })
  },
  updateStation(data: UPDATE_STATION_DATA[]) {
    const url = API.CONFIG_SETUP.STATION.UPDATE
    return axiosClient.put(url, data)
  },
}

export default setupApi
